import list from './posterManage'
export default list